import { MINIMUM_SEARCH_LENGTH } from './constants';
export { ElevioError } from './elevioError';
export function buildArticleUrl({ articleSlug, kbUrl, langCode, }) {
    return `${kbUrl}/${langCode}/articles/${articleSlug}`;
}
export function removeAnchorFromArticleId(id) {
    return id.split('#')[0];
}
export function removeAnchorFromMultipleArticleIds(articleIds) {
    return articleIds.map((articleId) => removeAnchorFromArticleId(articleId));
}
export function isValidSearchLength(searchTerm) {
    return searchTerm.length >= MINIMUM_SEARCH_LENGTH;
}
export function getUrl() {
    return window.location.href;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noOp = () => { }; // Not required - always a disabled field
export function getPreparedTags(tagNames) {
    return tagNames.length === 1
        ? `${tagNames[0]}`
        : tagNames.reduce((acc, t, i) => {
            if (i === tagNames.length - 1) {
                acc += `${t}`;
            }
            else {
                acc += `${t}<br/>`;
            }
            return acc;
        }, '');
}
